import { render, staticRenderFns } from "./searchTips.vue?vue&type=template&id=22a1eae6&"
import script from "./searchTips.vue?vue&type=script&lang=js&"
export * from "./searchTips.vue?vue&type=script&lang=js&"
import style0 from "./searchTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a1eae6')) {
      api.createRecord('22a1eae6', component.options)
    } else {
      api.reload('22a1eae6', component.options)
    }
    module.hot.accept("./searchTips.vue?vue&type=template&id=22a1eae6&", function () {
      api.rerender('22a1eae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/uiKit/searchTips.vue"
export default component.exports